import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';

const TestTelemetryConnection = ({ telemetryConnection }) => {
  const connectionStatus = (
    <span className="fa-layers fa-2x align-middle">
      <FontAwesomeIcon icon="plug" size="lg" transform="shrink-6" />
      <FontAwesomeIcon icon="ban" className="text-danger" />;
    </span>
  );
  // if (connectionWebsocket) { // webSocket comentado
  //   connectionStatus = (
  //     <FontAwesomeIcon icon="plug" size="2x" className="text-success align-middle" />
  //   );
  // }
  const separator = ':  ';
  return (
    <>
      <div className="d-flex flex-row align-items-center">
        <div>Telemetry Connection Test for</div>
        <Button variant="link" className="px-1">
          {telemetryConnection}
        </Button>
        <div>{separator}</div>
        <div className="pl-1">{connectionStatus}</div>
      </div>
    </>
  );
};

TestTelemetryConnection.propTypes = {
  // connectionWebsocket: PropTypes.bool.isRequired, // webSocket comentado
  telemetryConnection: PropTypes.string.isRequired
};

export default TestTelemetryConnection;
